import { layout } from '@vitness/tokens';
import { useMediaQuery } from './useMediaQuery.js';

export interface BreakpointState {
  /** Below the tablet tier — the touch shell: drawer + bottom nav. */
  isMobile: boolean;
  /** Between the tablet and desktop tiers — the icon rail, no bottom nav. */
  isTablet: boolean;
  /** At or above the desktop tier — the full expanded sidebar. */
  isDesktop: boolean;
}

/**
 * Which of the three shell shapes applies.
 *
 * The three are mutually exclusive and exhaustive, which is the part that used
 * to be got wrong: consumers wrote `isMobile = !isDesktop` and thereby handed
 * the whole 768–1023 band — iPad portrait, a half-screen laptop window — a
 * phone's navigation on a screen wide enough for a desktop's content. Read
 * `isMobile` when you mean "no room for a rail", not "not a desktop".
 */
export function useBreakpoint(): BreakpointState {
  const isDesktop = useMediaQuery(`(min-width: ${layout.desktop}px)`);
  const isTabletUp = useMediaQuery(`(min-width: ${layout.tablet}px)`);

  return {
    isMobile: !isTabletUp,
    isTablet: isTabletUp && !isDesktop,
    isDesktop,
  };
}
